module.exports = __webpack_public_path__ + "img/seminar7.ae6cbd44.jpg";